import React from "react";
import { Gift, Check } from "lucide-react";
import { computeByob } from "@/utils/pricing";

export const BundleBuilderBanner = ({ byob, products, cart }) => {
  const b = computeByob(byob, products, cart);
  if (!b) return null;
  const pct = Math.min(100, Math.round((b.units / b.minUnits) * 100));
  return (
    <div
      className={`mt-6 rounded-2xl border px-4 py-4 sm:px-6 shadow-[0_10px_40px_rgba(0,0,0,0.35)] ${b.qualified ? "border-emerald-400/50 bg-emerald-500/[0.08]" : "border-[#F4A93A]/40 bg-gradient-to-r from-[#0A2438] to-[#0F1E2C]"}`}
      data-testid="byob-banner"
    >
      <div className="flex items-start gap-3 flex-wrap sm:flex-nowrap">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${b.qualified ? "bg-emerald-400 text-[#040A0F]" : "bg-[#F4A93A]/20 text-[#F4A93A]"}`}>
          {b.qualified ? <Check className="w-5 h-5" /> : <Gift className="w-5 h-5" />}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-serif text-lg text-[#F6F1E4] leading-tight" data-testid="byob-banner-title">
            {b.qualified ? `Bundle unlocked — ${b.percent}% off your baby gear` : "Create your own bundle"}
          </div>
          <div className="text-xs text-[#B9C8D5] mt-1" data-testid="byob-banner-hint">
            {b.qualified
              ? `${b.units} eligible items added — your ${b.percent}% discount is applied at checkout.`
              : b.units === 0
                ? `Choose ${b.minUnits} or more baby items (strollers and ECVs excluded) and save ${b.percent}%. Discount applied at checkout.`
                : `${b.units} of ${b.minUnits} added — ${b.remaining} more baby ${b.remaining === 1 ? "item" : "items"} to unlock ${b.percent}% off. Discount applied at checkout.`}
          </div>
          <div className="mt-3 flex items-center gap-3">
            <div className="flex-1 h-2 rounded-full bg-black/40 overflow-hidden" role="progressbar" aria-valuenow={b.units} aria-valuemin={0} aria-valuemax={b.minUnits}>
              <div
                className={`h-full rounded-full transition-[width] duration-500 ${b.qualified ? "bg-emerald-400" : "bg-[#F4A93A]"}`}
                style={{ width: `${pct}%` }}
                data-testid="byob-progress-fill"
              />
            </div>
            <span className="text-xs text-[#F6F1E4] tabular-nums shrink-0" data-testid="byob-progress-count">
              {Math.min(b.units, b.minUnits)}/{b.minUnits}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
